import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RiDeleteBin6Fill } from 'react-icons/ri';
import { LiaShoppingBagSolid } from 'react-icons/lia';
import CartServices from '../services/API/CartService';
import { BASE_URL } from '../services/Constant';
import { MdShoppingCart } from 'react-icons/md';
import { FaArrowRight } from 'react-icons/fa';

const Sidebar = ({ isOpen, toggleSidebar, cartProducts, increment, decrement, count, handleDeleteCartById }) => {
  return (
    <>
      <div className={`px-2 h-screen fixed top-0 right-0 w-96 bg-white shadow-lg transform ${isOpen ? 'translate-x-0' : 'translate-x-full'} transition-transform duration-300 ease-in-out z-50`}> 
        <div className="p-4 border-b flex justify-between items-center">
          <h2 className="text-lg font-semibold">Cart</h2>
          <button className="text-gray-500 hover:text-gray-700" onClick={toggleSidebar}>×</button>
        </div>
        <div className="p-4 space-y-4 overflow-y-auto h-[80vh] text-left">
          {cartProducts.length > 0 ? (
            cartProducts.map(cartItem => (
              <div key={cartItem.id} className='flex items-start justify-between p-3 border rounded-lg shadow-sm'>
                <img src={cartItem.products.productImage} alt={cartItem.products.name} className='w-16 h-16 rounded-md'/>
                <div className='flex-1 ml-3'>
                  <p className='font-medium text-xs'>{cartItem.products.name}</p>
                  <p className='text-gray-500 text-sm'>${cartItem.products.price}</p>
                  <div className='flex items-center gap-2 mt-2'>
  <button onClick={() => decrement(cartItem.id, cartItem.quantity)} className='bg-gray-200 px-2 py-1 rounded'>-</button>
  <span className='font-semibold'>{cartItem.quantity.toString().padStart(2, '0')}</span>
  <button onClick={() => increment(cartItem.id, cartItem.quantity)} className='bg-gray-200 px-2 py-1 rounded'>+</button>
</div>

                </div>
                <RiDeleteBin6Fill onClick={() => handleDeleteCartById(cartItem.id)} className='text-red-500 cursor-pointer' size={20} />
              </div>
             
            ))
          ) : (
            <div className="flex flex-col items-center justify-center  text-center px-4">
                            <MdShoppingCart className="text-6xl text-gray-400" />
                            <h2 className="text-2xl font-semibold mt-4">Your cart is empty</h2>
                            <p className="text-gray-500 mt-2">Looks like you haven't added anything to your cart yet.</p>
                            <Link to="/" className="mt-5">
                                <button className="px-6 py-3 bg-[#F4CF38] text-black font-bold rounded-lg transition flex align-items-center gap-2 m-0">
                                    Continue Shopping <FaArrowRight/>
                                </button>
                            </Link>
                        </div>
          )}
        </div>
        <Link to="/checkout">
                                <button className="px-6 py-3 bg-[#F4CF38] text-black font-bold rounded-lg transition flex align-items-center gap-2 m-0 w-full justify-between">
                                    Checkout <FaArrowRight/>
                                </button>
                            </Link>
      </div>
      {isOpen && <div className="fixed inset-0 bg-black bg-opacity-50 z-40" onClick={toggleSidebar}></div>}
    </>
  );
};

export default Sidebar;
